module.exports = __webpack_public_path__ + "static/media/SofiaProExtraLight.8b590b22.otf";